import { render, staticRenderFns } from "./MagicLink.vue?vue&type=template&id=3094db50&scoped=true&"
import script from "./MagicLink.vue?vue&type=script&lang=js&"
export * from "./MagicLink.vue?vue&type=script&lang=js&"
import style0 from "./MagicLink.vue?vue&type=style&index=0&id=3094db50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3094db50",
  null
  
)

export default component.exports